<template>
  <ContractTemplateEditor turnalFlag="add" @submitSuccess="submitSuccess"/>
</template>

<script>
import ContractTemplateEditor from './components/contractTemplateEditor.vue'
import { storageKeyAdd, storageTitleKeyAdd } from './config'
import { clearLocalStorage } from '@/utils/cache'
import WindowCommunication from '@/utils/windowCommunication'

export default {
  name: 'addContractTemp',
  components: {
    ContractTemplateEditor,
  },
  data() {
    return {
      storageKeyAdd,
      storageTitleKeyAdd,
    }
  },
  methods: {
    // 清除草稿
    clearCache() {
      clearLocalStorage(this.storageKeyAdd)
      clearLocalStorage(this.storageTitleKeyAdd)
    },
    submitSuccess(templateId) {
      this.sendMessage(templateId)
    },
    sendMessage(templateId) {
      // 跨页面通信 通知合同模板信息刷新
      if (this.$route.query.scene) {
        const communication = new WindowCommunication('personal_sign_contract')
        communication.send({
          type: 'contract_template_added',
          data: templateId,
        })
        // 关闭window
        window.close()
      }
    },
  },
  created() {
    this.$EventBus.$on('autoRemoveCache', this.clearCache)
  },
  beforeDestroy() {
    this.$EventBus.$off('autoRemoveCache', this.clearCache)
  },
}
</script>
